import { Box } from '@mui/material';
import React from 'react';

interface IProps {
  children: React.ReactNode;
}

const LoginPageLayout = ({ children }: IProps) => (
  <Box
    sx={{
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      px: 2,
      py: 4,
    }}
  >
    {children}
  </Box>
);

export default LoginPageLayout;
